var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneySvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 460 460",
    style: {
      enableBackground: "new 0 0 460 460"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEE187"
    },
    d: "M230,0C102.974,0,0,102.975,0,230c0,98.818,62.319,183.081,149.8,215.631l295.018-297.983 C411.694,61.299,328.006,0,230,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC61B"
    },
    d: "M460,230c0-29.02-5.389-56.778-15.198-82.347l-50.073-50.006L65.937,361.753l83.867,83.867 C174.776,454.912,201.792,460,230,460C357.025,460,460,357.026,460,230z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#71E2F0"
    },
    points: "216.654,183.728 230.5,287.569 380.883,287.569 380.883,197.574  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C2FBFF"
    },
    points: "230.5,107.576 216.654,197.574 380.883,197.574 380.883,107.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C2FBFF"
    },
    points: "79.783,197.908 79.783,287.902 230.5,287.569 230.5,197.574 161.27,176.805  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "79.783,107.914 79.783,197.908 230.5,197.574 230.5,107.576  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#71E2F0"
    },
    points: "394.729,361.42 230.5,361.42 223.577,333.728 394.729,341.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#38C6D9"
    },
    points: "394.729,341.42 230.5,341.42 223.577,312.956 394.729,321.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#71E2F0"
    },
    points: "394.729,321.42 230.5,321.42 223.577,292.187 394.729,301.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C2FBFF"
    },
    points: "150.885,334.383 65.937,341.753 65.937,361.42 230.5,361.42 230.5,341.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#71E2F0"
    },
    points: "230.5,341.42 65.937,341.42 65.937,321.753 150.885,312.956 230.5,321.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C2FBFF"
    },
    points: "230.5,321.42 65.937,321.42 65.937,301.753 230.5,292.187  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38C6D9"
    },
    d: "M230.5,147.581c28.677,0,51.92,23.243,51.92,51.919c0,28.671-23.243,51.92-51.92,51.92 l-11.538-51.92L230.5,147.581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71E2F0"
    },
    d: "M230.5,147.581V251.42c-28.677,0-51.92-23.248-51.92-51.92 C178.58,170.823,201.823,147.581,230.5,147.581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38C6D9"
    },
    d: "M342.466,117.58H230.5l-10-10.005l10-9.929h164.229V301.42H230.5l-10-9.232l10-10.768h111.966 c0-17.819,14.445-32.263,32.263-32.263v-99.313C356.911,149.844,342.466,135.399,342.466,117.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71E2F0"
    },
    d: "M118.201,117.58H230.5V97.647H65.937V301.42H230.5v-20H118.201c0-17.819-14.445-31.93-32.263-31.93 v-99.313C103.756,150.177,118.201,135.399,118.201,117.58z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneySvgrepoCom);
export default __webpack_public_path__ + "static/media/money-svgrepo-com.e707a0b26a5e46f9504a79647f636903.svg";
export { ForwardRef as ReactComponent };